import { render, staticRenderFns } from "./hospitalInfo.vue?vue&type=template&id=f905bbb8&scoped=true&"
import script from "./hospitalInfo.vue?vue&type=script&lang=js&"
export * from "./hospitalInfo.vue?vue&type=script&lang=js&"
import style0 from "./hospitalInfo.vue?vue&type=style&index=0&id=f905bbb8&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f905bbb8",
  null
  
)

export default component.exports